import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Typography from '@mui/material/Typography';

import DropZone from 'components/Shared/DropZone';

import MotifResolutionSelect from './MotifResolutionSelect';
import CausePrincipaleSelect from './CausePrincipaleSelect';
import CausePrincipaleDetailSelect from './CausePrincipaleDetailSelect';


const styles = theme => ({
    formControl: {
        marginTop: '20px',
        marginBottom: '20px',
        width: '100%'
    },
    noScrollable: {
        overflowY: 'hidden'
    },
    dialogPaper: {
        maxHeight: '90vh'
    },
    message: {
        marginTop: '8px',
        color: theme.palette.secondary.main
    }
});

class ClotureContent extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            motifResolutionId: '',
            causePrincipaleId: '',
            causePrincipaleDetailId: '',

            fichiersIds: [],
        };
    }

    componentDidMount() {
        let clotureData = this.getClotureData(this.state);

        this.props.onChange(clotureData);
    }


    getClotureData(newState) {

        const { motifsResolution, causesPrincipales } = this.props;

        let motifResolution = motifsResolution.find(x => x.id === newState.motifResolutionId);
        let causePrincipale = causesPrincipales.find(x => x.id === newState.causePrincipaleId);

        let clotureData = {
            motifResolutionCode: motifResolution ? motifResolution.code : '',
            causePrincipaleCode: causePrincipale ? causePrincipale.code : '',
            causePrincipaleDetailId: newState.causePrincipaleDetailId,
            utilisateurFautifId: 0,
            commentaire: '',
            mailAutomatique: '',
            fichiersIds: newState.fichiersIds
        };

        return clotureData;
    }

    handleChange = (event) => {

        let newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        let clotureData = this.getClotureData(newState);

        this.props.onChange(clotureData);
    }




    render() {
        const { classes, motifsResolutionMessage, motifsResolution, causesPrincipales, withDropzone, autoFocus } = this.props;

        const { motifResolutionId, causePrincipaleId, causePrincipaleDetailId } = this.state;

        let causePrincipaleDetails = [];
        if (causesPrincipales) {
            let causePrincipale = causesPrincipales.find(x => x.id === causePrincipaleId);
            if (causePrincipale) {
                causePrincipaleDetails = causePrincipale.details;
            }
        }

        return (

            <React.Fragment>
                <div className={classes.formControl}>
                    <MotifResolutionSelect
                        value={motifResolutionId}
                        required
                        onChange={this.handleChange}
                        motifsResolution={motifsResolution}
                        autoFocus={autoFocus}
                    />

                    <Typography className={classes.message} variant="caption">
                        {motifsResolutionMessage}
                    </Typography>
                </div>

                <div className={classes.formControl}>
                    <CausePrincipaleSelect
                        value={causePrincipaleId}
                        required
                        onChange={this.handleChange}
                        causesPrincipales={causesPrincipales}
                    />
                </div>


                {
                    causePrincipaleDetails && causePrincipaleDetails.length > 0 && (
                        <div className={classes.formControl}>
                            <CausePrincipaleDetailSelect
                                value={causePrincipaleDetailId}
                                onChange={this.handleChange}
                                causePrincipaleDetails={causePrincipaleDetails}
                            />
                        </div>
                    )
                }


                {withDropzone &&
                    <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
                }

            </React.Fragment>
        );
    }
}

ClotureContent.propTypes = {
    reclamationId: PropTypes.number.isRequired,
    withDropzone: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired
};


ClotureContent.defaultProps = {
    withDropzone: false,
    autoFocus: true
};

export default withStyles(styles)(ClotureContent);

